import React from 'react';
import { IPriceAlert } from '@kattana-io/common';
import Image from '../../../atoms/Image';
import Text from '../../../atoms/Text';
import alertOff from '../../../assets/images/alarm_remove.svg';

type IProps = {
  alert: IPriceAlert;
  // eslint-disable-next-line no-unused-vars
  actionConsumePriceAlert: () => void;
  isNew: boolean;
};

const AlertItemMemo = React.memo(function AlertItem(props: IProps) {
  const { alert, actionConsumePriceAlert, isNew } = props;

  const price = alert.price_usd ? `${alert.price_usd} USD` : alert.price;

  const [base, quote] = alert.name.split('/');
  const alertPair = alert.flipped ? `${quote}/${base}` : `${base}/${quote}`;

  return (
    <div className={`row alertItem${isNew ? ' alertItem--new' : ''}`}>
      <div className='row'>
        <Text size={14} className='text--grey-200 text--weight-500'>
          {alertPair}
        </Text>
        <Text size={14} className='text--grey-200 text--weight-500'>
          {price}
        </Text>
      </div>
      <Image
        size='s'
        src={alertOff}
        onClick={(e: MouseEvent) => {
          e.stopPropagation();
          actionConsumePriceAlert();
        }}
      />
    </div>
  );
});

export default AlertItemMemo;
